export default __webpack_public_path__ + "static/media/image-home-banner.33f2576b.svg";